import { defineStore } from 'pinia'
import bulkDataApi from '@/api/bulkdata'
import type { RentSourceBulkDataSubscriptionAttributes } from 'common'

export const useBulkDataStore = defineStore('bulkdata', {
  state: () => ({
    activeSubscriptions: [] as RentSourceBulkDataSubscriptionAttributes[]
  }),
  actions: {
    async refreshList() {
      this.activeSubscriptions = await bulkDataApi.list()
    },
    async get(id: number) {
      return bulkDataApi.get(id)
    },
    async update(
      id: number,
      body: { emails_enabled: boolean; emails: string[]; schedule: string[] }
    ) {
      const data = await bulkDataApi.update(id, body)
      const existingRecordIndex = this.activeSubscriptions.findIndex((_) => _.id === id)
      if (existingRecordIndex > -1 && data) {
        this.activeSubscriptions = [data]
          .concat(this.activeSubscriptions.slice(0, existingRecordIndex))
          .concat(this.activeSubscriptions.slice(existingRecordIndex + 1))
      }
      return data
    },
    sendEmail(id: number) {
      return bulkDataApi.sendEmail(id)
    }
  }
})
